export default {
  data() {
    return {
      // eslint-disable-next-line
      skillOptions: [
        "Accounting",
        "Admin",
        "Business",
        "Calculation",
        "Clean",
        "Review Business",
        "Review Technical",
        "Big Data",
        "Civil Building",
        "Electrical Switching",
        "Electrical Troubleshooting",
        "Electrical Wiring",
        "English Low",
        "English Medium",
        "English High",
        "Test Mechanical",
        "Marketing",
        "Mechanical Rotating",
        "Mechanical Static",
        "Metal Mods",
        "Presentation",
        "Report",
        "Procedure",
        "Programming",
        "Plumbing",
        "Risk Assessment",
        "Scaffold",
        "Timber",
        "Welding Aluminium",
        "Welding Steel"
      ],
      certificateOptions: [
        "Bachelor",
        "CPA",
        "Cert I",
        "Cert II",
        "Cert III",
        "Cert IV",
        "Diploma",
        "Drilling Operations",
        "EEHA",
        "Gas Test",
        "High Pressure",
        "High Voltage",
        "Induction Site",
        "OHL",
        "Professional Engineer",
        "Project Management",
        "Masters",
        "MBA",
        "Switching LV",
        "Switching HV",
        "Workplace HSE"
      ],
      competencyOptions: [
        "AI",
        "Asset Management",
        "Commissioning",
        "Console Ops",
        "Construction",
        "Crisis Management",
        "Detail Design",
        "Drawings Sign off",
        "Engineering Minor",
        "Engineering Major",
        "Heavy Machine Operation",
        "Inspection EEHA",
        "Inspection Electrical",
        "Inspection Mechanical",
        "Logic Mods",
        "Maintenance EEHA",
        "Maintenance Electrical",
        "Maintenance Mechanical",
        "Machine Learning",
        "Marine Ops",
        "Mine Ops",
        "Offshore Ops",
        "Personal Safety",
        "Process Safety",
        "Resource and Planning",
        "Strategy Planning",
        "Team Management",
        "Working at Heights",
        "Working on Ropes",
        "Working Underground"
      ],
      // eslint-disable-next-line
      licenceOptions: [
        "Builder",
        "Building Surveyor",
        "Driver Car",
        "Driver Truck",
        "Driver Forklift",
        "Mechanical",
        "Painter",
        "Plumber",
        "Electrical Worker",
        "Gas Fitter",
        "Demolition Worker",
        "Pest Controller"
      ]
    };
  }
};
